export const createMediaStreamTrackProcessor = init => {
    const processor = new MediaStreamTrackProcessor(init);
    return processor;
};
//# sourceMappingURL=processor.js.map